/**
 * Natures de fichier d'un dossier client.
 *
 * Doit rester alignée sur la contrainte `chk_documents_client_categorie`
 * (migrations 049 et 061) et sur `documentClientService.CATEGORIES` côté
 * serveur : une valeur qui n'y figure pas est refusée en 400.
 *
 * Partagée entre la fiche d'une demande et le panneau de saisie manuelle :
 * les deux offrent le même choix, et une nature ajoutée ici apparaît des deux
 * côtés sans qu'on ait à y penser.
 *
 * « Feuille de présence » désigne ici une feuille REÇUE — signée sur papier,
 * scannée, rapatriée d'un dossier traité ailleurs. Celle que l'application
 * produit vit dans `documents_session`, avec ses cases et ses signatures.
 */
export const CATEGORIES_DOCUMENT = [
  { valeur: 'devis', label: 'Devis' },
  { valeur: 'contrat', label: 'Contrat' },
  { valeur: 'convention', label: 'Convention' },
  { valeur: 'attestation', label: 'Attestation' },
  { valeur: 'feuille_presence', label: 'Feuille de présence' },
  { valeur: 'piece', label: 'Pièce du client' },
  { valeur: 'autre', label: 'Autre' },
];

/** Libellé d'une nature, pour l'affichage d'une pièce déjà déposée. */
export const LIBELLE_CATEGORIE = Object.fromEntries(
  CATEGORIES_DOCUMENT.map((c) => [c.valeur, c.label])
);

/** Extensions proposées au sélecteur de fichier. */
export const FORMATS_ACCEPTES = '.pdf,.jpg,.jpeg,.png,.webp,.doc,.docx';
